import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { Grid, GridCell } from './index'
import { FieldLayoutBox } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser, FieldValueConverters } from './FieldValueConverters'
import { BooleanFormatter } from './Formatters/BooleanFormatter'

export class SwitchBoxClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    readonlyTrueValue: pt.any,
    readonlyFalseValue: pt.any
  })

  static defaultProps = {
    readonlyTrueValue: 'On',
    readonlyFalseValue: 'Off'
  }

  render () {
    const { switchActiveValue = 'Yes', switchInactiveValue = 'No', readonlyTrueValue, readonlyFalseValue, switchLabel = '', ...rest } = this.props
    return (
      <FieldLayoutBox {...rest} isFieldSet={true}>
        {({ testId, showError, value, onChange, name, placeHolder, loading, readonly, label }) => {
          if (readonly) {
            var formattedValue = BooleanFormatter({ trueValue: readonlyTrueValue, falseValue: readonlyFalseValue, value: value })
            return <input data-tid={testId} type='text' readOnly name={`view${name}`} id={`view${name}`} value={formattedValue} />
          } else {
            return <>
              <div className="device-toggle">
                <Grid paddingX marginX>
                  <GridCell medium={3} className="text-right">
                    <div className="switch small">
                      <input className="switch-input" data-tid={testId} disabled={loading} id={`switch${name}`} name={`switch${name}`} invalid={showError} onChange={onChange} checked={value} type="checkbox" />
                      <label className="switch-paddle" htmlFor={`switch${name}`}>
                        <span className="switch-active" aria-hidden="true">{switchActiveValue}</span>
                        <span className="switch-inactive" aria-hidden="true">{switchInactiveValue}</span>
                      </label>
                    </div>
                  </GridCell>
                  <GridCell medium={3}>{switchLabel}</GridCell>
                </Grid>
              </div>
            </>
          }
        }}
      </FieldLayoutBox>
    )
  }
};

export const SwitchBox = ({ parse, format, fieldType = FieldValueConverters.Boolean, name, namePrefix, ...rest }) => { return <Field name={namePrefix ? `${namePrefix}.${name}` : name} parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={SwitchBoxClass} /> } // eslint-disable-line
export default SwitchBox
